import { ChangeEvent, CSSProperties } from "react";


export interface ProductImage {
  id: number;
  product_category_id: number;
  product_group_id: number;
  product_family_id?: number;
  product_sub_family_id?: number;
  title: string;
  file_name: string;
  new?: boolean;
}

export interface ProductDetail {
  FamilyList?: any[];
  GroupFamilySubfamilyData?: any;
  GroupFamilySubfamilyfile?: any[];
  Products?: any[];
}

export interface ProductSpecification {
  id: number;
  name: string;
  value: string;
}

export interface ProductDocument {
  title: string;
  url: string;
}

export interface IFilterObj {
  diameter: Array<{ id: string; name: string }>;
  system_power: Array<{ id: string; name: string }>;
  color_temperature: Array<{ id: string; name: string }>;
  light_control: Array<{ id: string; name: string }>;
  fixture_type: Array<{ id: string; name: string }>;
  lm_name: Array<{ id: string; name: string }>;
  cri: Array<{ id: string; name: string }>;
  material: Array<{ id: string; name: string }>;
  ip_rating: Array<{ id: string; name: string }>;
  product_ik: Array<{ id: string; name: string }>;
  colour_finish: Array<{ id: string; name: string }>;
  beam_diffuser: Array<{ id: string; name: string }>;
  switch_control: Array<{ id: string; name: string }>;
  unified_glare_rating: Array<{ id: string; name: string }>;
}



export enum EPageLinks {
  "Home" = "/",
  "SignIn" = "/sign-in",
  "Dashboard" = "/dashboard",
  "ForgotPassword" = "/forgot-password",
  "SignUp" = "/sign-up",
  "Users" = "/users",
  "Roles" = "/roles",
  "Permissions" = "/permissions",
  "StandardProducts" = "/standard-products",
  "NonStandardProducts" = "/non-standard-products",
  "BOQExcel" = "/boq-excel",
  "Projectlist" = "/project/list",
  "BOQComparison" = "/boq-comparison/:id",
  "BOQComparisonCostAndPrice" = "/boq-comparison-cost-price/:id",
  "BOQManagement" = "/boq-management",
  "BOQData" = "/boq-data",
  "ProductBeamAngle" = "/product-beam-angle",
  "ProductBeamDiffuser" = "/product-beam-diffuser",
  "ProductCg" = "/profuct-cg",
  "ProductCe" = "/product-ce",
  "ProductCri" = "/product-cri",
  "ProductCt" = "/product-ct",
  "ProductDia" = "/product-dia",
  "ProductDiffuser" = "/product-diffuser",
  "ProductDirectIndirect" = "/product-direct-indirect",
  "ProductFinish" = "/product-finish",
  "ProductFixture" = "/product-fixture",
  "ProductFlux" = "/product-flux",
  "ProductGroup" = "/product-group",
  "ProductHc" = "/product-hc",
  "ProductHeight" = "/product-height",
  "ProductIk" = "/product-ik",
  "ProductIp" = "/product-ip",
  "ProductKelvin" = "/product-kelvin",
  "ProductLc" = "/profuct-lc",
  "ProductLdc" = "/profuct-ldc",
  "ProductLength" = "/profuct-length",
  "ProductLm" = "/profuct-lm",
  "ProductMaterial" = "/product-material",
  "ProductName" = "/product-name",
  "ProductPhotobiological" = "/product-photobiological",
  "ProductPower" = "/product-power",
  "ProductProfile" = "/product-profile",
  "ProductSdcm" = "/product-sdcm",
  "ProductSensor" = "/product-sensor",
  "ProductShape" = "/product-shape",
  "ProductType" = "/product-type",
  "ProductUgr" = "/product-ugr",
  "ProductAdd" = "/products/add",
  "ProductEdit" = "/products/edit/:productId",
  "NotFound" = "/404",
  "Exception" = "*",
  "Projects" = "/projects",
  "Projects1" = "/project/list",
  "ProjectAdd" = "/project/add",
  "ProjectEdit" = "/project/edit/:projectId",
  "Information" = `/project/edit/information/:projectId`,
  "BOQManagement1" = "/project/edit/boq-management/:projectId",
  "BOQData1" = "/project/edit/boq-data/:projectId/*",
  "PreSpecification" = "/project/edit/pre-specification/:projectId",
  "FinalSpecification" = "/project/edit/final-specification/:projectId",
  "Commercials" = "/project/edit/commercials/:projectId/*",
  "Quotation" = "/project/edit/quotation/:projectId/*",
  "Sampling" = "/project/edit/sampling/:projectId/*",
  "Design" = "/project/edit/design/:projectId/*",
  "Handover" = "/project/edit/handover/:projectId/*",
  "ProjectPlan" = "/project/edit/project-plan/:projectId/*",
  "SupplyChain" = "/project/edit/supply-chain/:projectId/*",
  "ProjectSupport" = "/project/edit/project-support/:projectId/*",
  "Warranty" = "/project/edit/warranty/:projectId/*",
  "Attributes" = "/attributes",
  "AttributesAdd" = "/attributes/add",
  "AttributesEdit" = "/attributes/edit/:attributeId",
  "FormComponents" = "/form-components",
  "FormComponentsAdd" = "/form-components/add",
  "FormComponentsEdit" = "/form-components/edit/:formComponentId",
  "AttributeCategory" = "/attribute-category",
  "FormComponentCategory" = "/form-component-Category",
  "Components" = "/components",
  "ComponentsBill" = "/components-bill",
  "ComponentsBillAdd" = "/components-bill/add",
  "ComponentsBillEdit" = "/components-bill/edit/:componentBillId",
  "ComponentDetails" = "/components/:componentTitle",
  "ProductImageTypeMaster" = "/product-image-type-master",
  "ProductFileTypeMaster" = "/product-file-type-master",
}

export enum EBackendPageRouterLinks {
  "Home" = "/dashboard",
  "SignIn" = "/sign-in",
  "Dashboard" = "/dashboard",
  "ForgotPassword" = "/forgot-password",
  "SignUp" = "/sign-up",
  "Users" = "/users",
  "Roles" = "/roles",
  "Permissions" = "/permissions",
  "StandardProducts" = "/standard-products",
  "NonStandardProducts" = "/non-standard-products",
  "BOQExcel" = "/boq-excel",
  "BOQComparison" = "/boq-comparison/:id",
  "BOQComparisonCostAndPrice" = "/boq-comparison-cost-price/:id",
  "BOQManagement" = "/boq-management",
  "BOQData" = "/boq-data",
  "ProductBeamAngle" = "/product-beam-angle",
  "ProductBeamDiffuser" = "/product-beam-diffuser",
  "ProductCg" = "/profuct-cg",
  "ProductCe" = "/product-ce",
  "ProductCri" = "/product-cri",
  "ProductCt" = "/product-ct",
  "ProductDia" = "/product-dia",
  "ProductDiffuser" = "/product-diffuser",
  "ProductDirectIndirect" = "/product-direct-indirect",
  "ProductFinish" = "/product-finish",
  "ProductFixture" = "/product-fixture",
  "ProductFlux" = "/product-flux",
  "ProductGroup" = "/product-group",
  "ProductHc" = "/product-hc",
  "ProductHeight" = "/product-height",
  "ProductIk" = "/product-ik",
  "ProductIp" = "/product-ip",
  "ProductKelvin" = "/product-kelvin",
  "ProductLc" = "/profuct-lc",
  "ProductLdc" = "/profuct-ldc",
  "ProductLength" = "/profuct-length",
  "ProductLm" = "/profuct-lm",
  "ProductMaterial" = "/product-material",
  "ProductName" = "/product-name",
  "ProductPhotobiological" = "/product-photobiological",
  "ProductPower" = "/product-power",
  "ProductProfile" = "/product-profile",
  "ProductSdcm" = "/product-sdcm",
  "ProductSensor" = "/product-sensor",
  "ProductShape" = "/product-shape",
  "ProductType" = "/product-type",
  "ProductUgr" = "/product-ugr",
  "ProductAdd" = "/products/add",
  "ProductEdit" = "/products/edit/:productId",
  "NotFound" = "/404",
  "Exception" = "*",
  "Projects" = "/projects",
  "Projectlist" = "/project/list",
  "ProjectAdd" = "/project/add",
  "ProjectEdit" = "/project/edit/:projectId",
  "Information" = `/project/edit/information/:projectId`,
  "BOQManagement1" = "/project/edit/boq-management/:projectId",
  "BOQData1" = "/project/edit/boq-data/:projectId/*",
  "PreSpecification" = "/project/edit/pre-specification/:projectId",
  "FinalSpecification" = "/project/edit/final-specification/:projectId",
  "Commercials" = "/project/edit/commercials/:projectId/*",
  "Quotation" = "/project/edit/quotation/:projectId/*",
  "Sampling" = "/project/edit/sampling/:projectId/*",
  "Design" = "/project/edit/design/:projectId/*",
  "Handover" = "/project/edit/handover/:projectId/*",
  "ProjectPlan" = "/project/edit/project-plan/:projectId/*",
  "SupplyChain" = "/project/edit/supply-chain/:projectId/*",
  "ProjectSupport" = "/project/edit/project-support/:projectId/*",
  "Warranty" = "/project/edit/warranty/:projectId/*",
  "Attributes" = "/attributes",
  "AttributesAdd" = "/attributes/add",
  "AttributesEdit" = "/attributes/edit/:attributeId",
  "FormComponents" = "/form-components",
  "FormComponentsAdd" = "/form-components/add",
  "FormComponentsEdit" = "/form-components/edit/:formComponentId",
  "AttributeCategory" = "/attribute-category",
  "FormComponentCategory" = "/form-component-Category",
  "Components" = "/components",
  "ComponentsBill" = "/components-bill",
  "ComponentsBillAdd" = "/components-bill/add",
  "ComponentsBillEdit" = "/components-bill/edit/:componentBillId",
  "ComponentDetails" = "/components/:componentTitle",
  "ProductImageTypeMaster" = "/product-image-type-master",
  "ProductFileTypeMaster" = "/product-file-type-master",
}

export enum EFieldInputTypes {
  "Select" = "select",
  "SelectMultiple" = "select-multiple",
  "Datalist" = "datalist",
  "Checkbox" = "checkbox",
  "Checkboxes" = "checkboxes",
  "Radio" = "radio",
  "Button" = "button",
  "Color" = "color",
  "Date" = "date",
  "DatetimeLocal" = "datetime-local",
  "Email" = "email",
  "File" = "file",
  "Hidden" = "hidden",
  "Image" = "image",
  "Month" = "month",
  "Number" = "number",
  "Password" = "password",
  "Range" = "range",
  "Reset" = "reset",
  "Search" = "search",
  "Submit" = "submit",
  "Tel" = "tel",
  "Text" = "text",
  "Time" = "time",
  "Url" = "url",
  "Week" = "week",
  "TextArea" = "textarea",
  "Custom" = "custom",
}

export interface IOnChangeEvent {
  target: { name: string; value: unknown; type?: EFieldInputTypes; checked?: boolean };
}

export type ExtraToChangeOnChangeForm = (form: IFormData) => { [k: string]: any };

export type OnChangeHandler = (event: IOnChangeEvent | ChangeEvent, extraToChange?: {}) => void;

export interface IInitialForm {
  [k: string]: unknown;
}
export interface IInitialSearchForm {
  [k: string]: unknown;
}

export interface IFieldDependency<N = string> {
  name: N;
  initialValue?: string | number | null;
  viewName?: string;
}

export interface IFieldProps<Name = string, Value = unknown> {
  id?: string;
  name: Name;
  title: string;
  placeholder?: string;
  initialValue?: string | number | null;
  value?: Value;
  multiple?: boolean | ((form: IFormData) => boolean);
  viewValue?: string;
  accept?: string;
  onChange?: OnChangeHandler;
  onChange1?: OnChangeHandler;
  required?: boolean | ((form: IFormData) => boolean);
  setter?: (value: Value, form: IFormData) => any;
  dependencies?: Array<IFieldDependency<Name>>;
  hideInFormOnCondition?: (formData: IFormData) => boolean;
  error?: string;
  readOnly?: boolean | ((formData: IFormData) => boolean);
}

export interface IFieldTextProps<Name = string, Value = unknown> extends IFieldProps<Name, Value> {
  min?: number;
  max?: number;
  minLength?: number;
  maxLength?: number;
  inputType?: EFieldInputTypes;
}

export interface IFieldSelectProps<Name = string, Value = unknown>
  extends IFieldProps<Name, Value> {
  options?: ISelectOption<Value>[];
  viewName?: string;
  noEmptyOption?: boolean;
}

export interface IField<Name = string, Value = unknown, Data = unknown>
  extends IFieldTextProps<Name, Value>,
    IFieldSelectProps<Name, Value> {
  filterable?: boolean;
  withExportButton?: boolean;
  hideInTable?: boolean;
  hideInForm?: boolean;
  hideInEditForm?: boolean;
  hideInSearchForm?: boolean;
  notSortable?: boolean;
  col?: number | any;
  searchCol?: number;
  columnWidth?: number;
  cell?: (value: Value, data: Data | IInitialForm) => any;
  cellAsImage?: boolean;
  headCellStyle?: CSSProperties;
  renderField?: (arg: IFieldProps<Name, Value>) => any;
  filterInputType?: EFieldInputTypes;
}

export enum EButtonThemes {
  "Light" = "light",
  "Dark" = "dark",
}

export interface IFormData {
  id?: number;
  [k: string]: unknown;
}

export interface IResponse<T = unknown> {
  id?: number;
  error?: string;
  message?: string;
  data?: T;
  responseData?: { [k: string]: any };
  total?: number;
  statusCode?: number;
  [k: string]: any;
}

export interface IPage {
  size: number;
  number: number;
}

export interface IApi<T, D = IFormData> {
  api: (data: D, pagination?: IPage) => Promise<IResponse<T>>;
  body?: IFormData;
}

export enum EApiNames {
  "Create" = "create",
  "Update" = "update",
  "Delete" = "delete",
  "EnableDisable" = "enabled_disable",
  "Restore" = "restore",
  "DeleteBatch" = "deleteBatch",
  "RestoreBatch" = "restoreBatch",
  "Remove" = "remove",
  "Get" = "get",
  "GetAll" = "getAll",
}
export interface IApis<T> {
  [EApiNames.Create]?: IApi<{ id: number }>;
  [EApiNames.Update]?: IApi<unknown>;
  [EApiNames.Delete]?: IApi<unknown>;
  [EApiNames.Restore]?: IApi<unknown>;
  [EApiNames.EnableDisable]?: IApi<unknown>;
  [EApiNames.DeleteBatch]?: IApi<unknown>;
  [EApiNames.RestoreBatch]?: IApi<unknown>;
  [EApiNames.Remove]?: IApi<unknown>;
  [EApiNames.GetAll]?: IApi<T[]>;
  [EApiNames.Get]?: IApi<T>;
}

export interface IAction<T extends string = string, P = unknown> {
  type: T;
  payload?: P;
  [key: string]: unknown;
}

export interface ISelectOption<V = number | string> {
  boq_name?: string;
  label: string;
  value?: V;
  col?: number | string;
  extraToChange?: {
    [k: string]: any;
  };
  input?: string;
}

export interface IProductObj {
  [k: string]: any;
}
